import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { profileApi } from '../lib/profile-api.js';
import { queryKeys } from '../lib/query-keys.js';
import type { UpdateProfileInput } from '../types/profile.js';

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business ログイン中ユーザー自身のプロフィール（GitHub ユーザー ID）をTanStack Query経由で取得
 * @graph-connects /profile [calls] プロフィール取得API
 * @graph-connects profileApi.getProfile [calls] プロフィールAPIクライアント呼び出し
 * @graph-connects queryKeys [calls] TanStack Queryキー生成
 */
export function useProfile() {
  return useQuery({
    queryKey: queryKeys.profile.detail(),
    queryFn: () => profileApi.getProfile(),
  });
}

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business プロフィール更新ミューテーション。GitHub ユーザー ID をPUT更新し、更新後の値でプロフィールキャッシュを置き換える
 * @graph-connects /profile [calls] プロフィール更新API（PUT）
 * @graph-connects profileApi.updateProfile [calls] プロフィール更新APIクライアント呼び出し
 * @graph-connects queryKeys [calls] TanStack Queryキー生成
 */
export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateProfileInput) => profileApi.updateProfile(data),
    onSuccess: (updated) => {
      // PUT のレスポンスが最新のプロフィールなのでキャッシュを置き換える
      queryClient.setQueryData(queryKeys.profile.detail(), updated);
    },
  });
}
